import { View } from 'react-native';
import { SafeAreaView } from '_dependencies/safeArea';
import { WW, WH } from '_utils';
import { screenMargin, smallestMargin } from '_utils/sizes';
import SkeletonLoader from 'Components/SkeletonLoader';

const BookingSharingSelectedSkeletonLoader = () => {
    return (
        <SafeAreaView edges={['bottom', 'left', 'right']} style={{ backgroundColor: '#fff', height: '100%' }}>
            <SkeletonLoader variant="provider" style={{ flex: 1 }}>
                {/* Header skeleton */}
                <View style={styles.headerContainer}>
                    <SkeletonLoader variant="foreground" style={styles.backButton} />
                    <SkeletonLoader variant="foreground" style={styles.headerTitle} />
                </View>

                {/* Content container */}
                <View style={styles.contentContainer}>
                    {/* User info skeleton */}
                    <SkeletonLoader variant="background" style={styles.userInfoContainer}>
                        <SkeletonLoader variant="foreground" style={styles.userAvatar} />
                        <View style={styles.userTextContainer}>
                            <SkeletonLoader variant="foreground" style={styles.userName} />
                            <SkeletonLoader variant="foreground" style={styles.userTime} />
                        </View>
                    </SkeletonLoader>

                    {/* Request badge skeleton */}
                    <SkeletonLoader variant="foreground" style={styles.requestBadge} />

                    {/* Title skeleton */}
                    <SkeletonLoader variant="foreground" style={styles.titleSkeleton} />

                    {/* Content skeleton */}
                    <SkeletonLoader variant="foreground" style={styles.contentSkeleton} />
                    <SkeletonLoader variant="foreground" style={styles.contentSkeletonShort} />

                    {/* Time info skeletons */}
                    <View style={styles.timeInfoContainer}>
                        <SkeletonLoader variant="foreground" style={styles.timeIcon} />
                        <SkeletonLoader variant="foreground" style={styles.timeText} />
                    </View>

                    <View style={styles.timeInfoContainer}>
                        <SkeletonLoader variant="foreground" style={styles.timeIcon} />
                        <SkeletonLoader variant="foreground" style={styles.timeText} />
                    </View>

                    {/* Spacer */}
                    <View style={{ flex: 1 }} />

                    {/* Buttons skeleton */}
                    <SkeletonLoader variant="foreground" style={styles.primaryButton} />
                    <SkeletonLoader variant="foreground" style={styles.secondaryButton} />
                </View>
            </SkeletonLoader>
        </SafeAreaView>
    );
};

const styles = {
    headerContainer: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        paddingHorizontal: screenMargin,
        paddingVertical: smallestMargin,
        gap: smallestMargin,
    },
    backButton: {
        width: WW * 0.08,
        height: WW * 0.08,
        borderRadius: WW * 0.04,
    },
    headerTitle: {
        height: WH * 0.025,
        flex: 1,
        borderRadius: 4,
    },
    headerAction: {
        width: WW * 0.08,
        height: WW * 0.08,
        borderRadius: WW * 0.04,
    },
    contentContainer: {
        marginHorizontal: screenMargin,
        gap: smallestMargin,
        flex: 1,
    },
    userInfoContainer: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        paddingVertical: smallestMargin,
    },
    userAvatar: {
        width: WW * 0.12,
        height: WW * 0.12,
        borderRadius: (WW * 0.12) / 2,
        marginRight: screenMargin,
    },
    userTextContainer: {
        flex: 1,
        gap: WH * 0.01,
    },
    userName: {
        height: WH * 0.02,
        width: '60%' as const,
        borderRadius: 4,
    },
    userTime: {
        height: WH * 0.015,
        width: '40%' as const,
        borderRadius: 4,
    },
    requestBadge: {
        height: WH * 0.025,
        width: WW * 0.15,
        borderRadius: screenMargin * 1.5,
        alignSelf: 'flex-start' as const,
    },
    titleSkeleton: {
        height: WH * 0.03,
        width: '80%' as const,
        borderRadius: 4,
    },
    contentSkeleton: {
        height: WH * 0.02,
        width: '100%' as const,
        borderRadius: 4,
    },
    contentSkeletonShort: {
        height: WH * 0.02,
        width: '70%' as const,
        borderRadius: 4,
    },
    timeInfoContainer: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        gap: smallestMargin,
    },
    timeIcon: {
        width: WW * 0.04,
        height: WW * 0.04,
        borderRadius: 4,
    },
    timeText: {
        height: WH * 0.02,
        width: '60%' as const,
        borderRadius: 4,
    },
    primaryButton: {
        height: WH * 0.05,
        width: '100%' as const,
        borderRadius: 25,
    },
    secondaryButton: {
        height: WH * 0.05,
        width: '100%' as const,
        borderRadius: 25,
    },
};

export default BookingSharingSelectedSkeletonLoader;
